// extracted by mini-css-extract-plugin
export default {"container":"Products_container__9YQU9","products":"Products_products__yN+uK","menu":"Products_menu__VxkUQ","list":"Products_list__9DgNp","product":"Products_product__qV20b"};